import * as React from 'react'
import * as classNames from 'classnames'
import { AppBarClass } from '@sphinx/components-styles'
import { AppSwitcherIcon, SearchIcon as SearchImg } from '../icons'

export const AppBar: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...props
}) => (
  <header className={classNames(AppBarClass.container, className)} {...props}>
    {children}
  </header>
)

export const AppTitle: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...props
}) => (
  <div className={classNames(AppBarClass.appTitle, className)} {...props}>
    {children}
  </div>
)

export const AppBarActions: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...props
}) => (
  <div className={classNames(AppBarClass.appBarActions, className)} {...props}>
    {children}
  </div>
)

export const Avatar: React.FC<React.ImgHTMLAttributes<HTMLImageElement>> = ({
  children,
  className,
  ...props
}) => (
  <img className={classNames(AppBarClass.avatar, className)} {...props}>
    {children}
  </img>
)

interface SearchActionProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  ref?: React.Ref<HTMLInputElement>
}

export const SearchAction: React.FC<SearchActionProps> = ({
  className,
  ...props
}) => (
  <div className={classNames(AppBarClass.searchBox, className)}>
    <input className={AppBarClass.searchInput} placeholder=" " {...props} />
    <SearchImg className={AppBarClass.searchIcon} />
  </div>
)

type AppSwitcherProps = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
  icon?: React.FC
}

export const AppSwitcher: React.FC<AppSwitcherProps> = ({
  icon: SwitcherIcon = AppSwitcherIcon,
  className,
  ...props
}) => (
  <a className={classNames(AppBarClass.buttonSwitcher, className)} {...props}>
    <SwitcherIcon />
  </a>
)
